import { type ManualPaymentHistoryItem, manualPaymentsEndpoints } from "../../../api";
import { useStrapiList, type UseStrapiListOptions } from "../../../hooks/strapi";
import getErrorMessage from "../../../utils/getErrorMessage";
import handleError from "../../utils/handleError";

type UseManualPaymentHistoryProps = UseStrapiListOptions;

// Endpoint only accepts page/pageSize
interface LoadPaymentHistoryParams {
  page?: number;
  pageSize?: number;
}

/**
 * Hook for fetching manual payment history (paid invoices).
 */
const useManualPaymentHistory = (props: UseManualPaymentHistoryProps = {}) => {
  const {
    items: invoices,
    setItems: setInvoices,
    refresh,
    isLoading,
    ...other
  } = useStrapiList<ManualPaymentHistoryItem>({
    ...props,
    load: (params) => {
      const p: LoadPaymentHistoryParams = {};
      if (typeof params?.page === "number") p.page = params.page;
      if (typeof params?.pageSize === "number") p.pageSize = params.pageSize;
      return loadPaymentHistory(p);
    },
    onLoadError: (err: unknown) => {
      handleError(getErrorMessage(err, "Manual payment history loading failed"));
    },
  });

  return {
    invoices,
    setInvoices,
    refresh,
    isLoading,
    ...other,
  };
};

export const loadPaymentHistory = async (params?: LoadPaymentHistoryParams) => {
  try {
    return await manualPaymentsEndpoints.getPaymentHistory(params);
  } catch (err: unknown) {
    handleError(getErrorMessage(err, "Manual payment history loading failed"));
  }
};

export default useManualPaymentHistory;
